import {IUser} from '@/interfaces/user';
import {Options, Vue} from 'vue-class-component';
import Button from '@/components/button/button.vue';
import Dropdown from '@/components/dropdown/dropdown.vue';
import AuthRepository from '@/repositories/AuthRepository';

@Options({
    name: 'user-dropdown',
    components: {
        'app-button': Button,
        'app-dropdown': Dropdown
    }
})
export default class User extends Vue {
    isLogoutLoading: boolean = false;

    get user(): IUser {
        return this.$store.getters.user;
    }

    private async logout() {
        this.isLogoutLoading = true;
        await AuthRepository.logout().then(() => {
            this.$store.dispatch('logout');
        }).finally(()=>{
            this.isLogoutLoading= false;
        });
    }
}
